<template>
  <span 
    class="switch"
    :class="{
      'switch-active':value,
      'switch-inactive':!value
    }"
    :style="{minWidth:`${width}px`}"
    @click.prevent="change"
     >
     <i class="text" >{{hasText  ? (value ? activeText : inActiveText):'' }}</i>
  </span>
</template>

<script>
export default {
  name: 'GjwSwitch',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 48
    },
    hasText: {
      type: Boolean,
      default: false
    },
    activeText: {
      type: String,
      default: ''
    },
    inActiveText: {
      type: String,
      default: ''
    }
  },
  methods: {
    change() {
      this.$emit('change', !this.value)
    }
  }
}
</script>

<style lang="less" scoped>
.switch{
  display: inline-block;
  height: 20px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s linear;
  &::after{
    position: absolute;
    content: '';
    top: 2px;
    transition: left 0.2s linear;
    background: #ffffff;
    width: 16px;
    height: 16px;
    border-radius: 100%;
  }
  .text{
    display: inline-block;
    position: absolute;
    font-style: normal;
    font-size: 12px;
    line-height: 20px;
  }
  &.switch-active{
  background: @theme-grey-3;
    &::after{
      right: 2px;
    }
    .text{
      left: 4px;
      color: white;
    }
  }
  &.switch-inactive{
  background: @theme-color;
    &::after{
      left: 2px;
    }
    .text{
      right: 4px;
      color: #ffffff;
    }
  }
}
</style>
